const showOpenFilePickerPolyfill = (options) => {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = options.multiple || false;
    input.accept = options.types
      ? options.types
          .map((type) => type.accept)
          .flatMap((inst) => Object.keys(inst).flatMap((key) => inst[key]))
          .join(',')
      : '';

    input.addEventListener('change', () => {
      resolve(
        [...input.files].map((file) => {
          return {
            getFile: async () =>
              new Promise((resolve) => {
                resolve(file);
              }),
          };
        }),
      );
    });

    input.click();
  });
};

if (typeof window.showOpenFilePicker !== 'function') {
  window.showOpenFilePicker = showOpenFilePickerPolyfill;
}
